import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const res = await axios.get(`${API_URL}/automatedReports/emailDeliveryTrackings`, {
        params: criteria,
      });

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
